/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 2f4f2acb9ee5
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import { Info, Info$zodSchema } from "./info.js";
import {
  ResourceUpdateRequest,
  ResourceUpdateRequest$zodSchema,
} from "./resourceupdaterequest.js";

export type UpdateResourceByAssetIdGlobals = {
  cloud_name?: string | undefined;
};

export const UpdateResourceByAssetIdGlobals$zodSchema: z.ZodType<
  UpdateResourceByAssetIdGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type UpdateResourceByAssetIdRequest = {
  asset_id: string;
  ResourceUpdateRequest: ResourceUpdateRequest;
};

export const UpdateResourceByAssetIdRequest$zodSchema: z.ZodType<
  UpdateResourceByAssetIdRequest
> = z.object({
  ResourceUpdateRequest: ResourceUpdateRequest$zodSchema.describe(
    "The asset attributes to update.",
  ),
  asset_id: z.string().describe(
    "The asset ID of the resource. Must be a 32-character hexadecimal string.",
  ),
});

export type UpdateResourceByAssetIdResponse = ApiError | Info;

export const UpdateResourceByAssetIdResponse$zodSchema: z.ZodType<
  UpdateResourceByAssetIdResponse
> = z.union([
  ApiError$zodSchema,
  Info$zodSchema,
]);
